import { CatalogFilterValue } from '@/entities/catalog-old/types/type'

export const getFilteredProperties = (items: CatalogFilterValue[], searchValue: string) =>
	items.filter(filterValue => {
		const incomingValue = (filterValue.NAME ?? filterValue.VALUE.toString()).toLocaleLowerCase()
		const searchingValue = searchValue.toLocaleLowerCase()

		return incomingValue.includes(searchingValue)
	})
